import { globalBackendClient } from '@mimir/client-common/globals/backendClient';
import { standardItemEntryKeys } from '@mimir/common/dto/itemModelPrimitives';
import type { StandardItemEntryDto, GetItemsDto } from '@mimir/common/dto/itemModels';
import { api_getItems } from '@mimir/client-common/api/getItemsApi';

// The search-hit poll also asks for `mediaDuration` so a live item's growing
// duration (for a live TAMS item, derived server-side from its start anchor)
// refreshes on each poll, like a Mimir live recording.
const pollItemEntryKeys = [...standardItemEntryKeys, 'mediaDuration'] as const;

export const getItemsWithDefaultFields = async (itemIds: string[]): Promise<StandardItemEntryDto[]> =>
  api_getItems(globalBackendClient, itemIds, pollItemEntryKeys);

export const getItems = async <Key extends keyof (GetItemsDto)>(itemIds: string[], fields: Key[] | readonly Key[]): Promise<Pick<GetItemsDto, Key>[]> =>
  api_getItems(globalBackendClient, itemIds, fields);

